import { useNavigate } from "react-router-dom"
import { Header } from "../Header/Header"

export const HeroSection = () => {
    const Navigate = useNavigate()
    return (
        <>

            <div className="row" id="Home">
                <div className="col-12 p-0 ">
                    <video autoPlay loop muted className="video_bg" style={{ position: "relative" }}>
                        <source src="Static/Assets/Img/Bg3.mp4" type="video/mp4" />

                    </video>

                    <h5 className="text-center scroll_heading " style={{ color: '#ffcd84' }}>

                        <span style={{color: '#011c31'}} className=" cursor-pointer blink-text" onClick={() => Navigate('webinars')}>
                            
                            <img src="https://www.sdcollegeambala.ac.in/wp-content/uploads/2021/10/new.png" width={50} height={40} class="img-fluid me-1 " alt="..."></img>
                            <span className="gradient-title">
                                Upcoming Webinar
                            </span>
                            </span>

                        <marquee className="cursor-pointer mt-3" title='Student registration' onClick={() => Navigate('ExaminationStructure')}>Preparation for Insurance Professional Examinations</marquee>
                    </h5>
                </div>


            </div>
        </>
    )
}
